import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'cropStringPipe',
})
export class CropStringPipe implements PipeTransform {
	transform(value: string, from: number, to: number, prefix: string, suffix: string): string {
		const slicedValue = value.slice(from, to);
		const cropRangeLen = to - from;
		if (slicedValue.length < cropRangeLen) {
			return value;
		}
		return prefix + slicedValue.trim() + suffix;
	}
}
